/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  queryParams = {
    statusFilter: {
      refreshModel: false,
    },
  };

  // Services
  @service
  store;

  model() {
    return hash({
      people: this.store.findAll('person'),
      groups: this.store.findAll('group'),
      events: this.store.findAll('bookings/event', { include: 'bookings' }),
    });
  }
}
